import { render, staticRenderFns } from "./ModalAddStorageV2.vue?vue&type=template&id=0944f794&scoped=true&"
import script from "./ModalAddStorageV2.vue?vue&type=script&lang=js&"
export * from "./ModalAddStorageV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddStorageV2.vue?vue&type=style&index=0&id=0944f794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944f794",
  null
  
)

export default component.exports